import Vue from 'vue'

export default {
  list(payload) {
    return Vue.http.post('app-services/v2/survey/list', payload)
  },
  create(payload) {
    return Vue.http.post('surveys/v2/surveys/create', payload)
  },
  /**
   * @deprecated Use exportList() instead
   * @see exportList - New OBS endpoint: POST app-services/v2/survey/export-list
   */
  export({ companyId, userId, filters, utcOffset }) {
    return Vue.http.post('survey/export', { companyId, userId, filters, utcOffset })
  },
  exportList({ companyId, userId, filters, utcOffset }) {
    return Vue.http.post('app-services/v2/survey/export-list', {
      companyId,
      userId,
      filters,
      utcOffset
    })
  },
  listSources(payload) {
    return Vue.http.post('app-services/v2/survey/list/sources', payload)
  },
  delete(surveyId) {
    return Vue.http.delete(`app-services/v2/survey/${surveyId}`)
  }
}
